import React from 'react'
import styles from './Footer.module.css';

function Footer() {
    return (
        <div id="footer" >
            <div className={styles.footer}>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginLeft: '3%', marginRight: '3%' }}>
                    <div className={styles.mobFooterrow} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                        <img src="/footericons/location.svg" alt="" />
                        <h1 style={{ fontFamily: 'Cairo Light' }}>١٠٦ شارع النيل , الدور الخامس , الدقي , القاهرة</h1>
                    </div>
                    <div className={styles.mobFooterrow} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                        <img src="/footericons/clock.svg" alt="" />
                        <h1 style={{ fontFamily: 'Cairo Light' }}>السبت - الخميس / 9:00 صباحا - 6:00 مساء</h1>
                    </div>
                    <div className={styles.mobFooterrow} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                        <img src="/footericons/mail.svg" alt="" />
                        <h1>info@banknoteconsult.com</h1>
                    </div>
                    <div className={styles.mobFooterrow} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                        <img src="/footericons/phone.svg" alt="" />
                        <h1>
                            <a href="tel:+201000046940">(+20) 1000046940</a>
                            <span className='mx-2'>or</span>
                            <a href="tel:+201022290501">(+02) 102 229 0501</a>
                        </h1>
                    </div>
                 
                    <div className={styles.mobFooterrow} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                        <img src="/footericons/telephone.svg" alt="" />
                        <h1>0233365177</h1>
                    </div>
                    {/* <div className={styles.mobFooterrow} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                        <img src="/footericons/people.svg" alt="" />
                        <h1>Careers</h1>
                    </div> */}
                </div>
            </div >
            <div className={styles.socialicons} id="footericons">
                <a className="Linkedin" href="https://eg.linkedin.com/company/banknoteeg">

                    <img src="/socialicons/Linkedin.svg" alt="" />
                </a>
                <a className="x" href="https://x.com/Banknoteegypt">

                    <img src="/socialicons/x.svg" alt="" />
                </a>
                <a className="Facebook" href="https://www.facebook.com/Banknoteeg">

                    <img src="/socialicons/Facebook.svg" alt="" />
                </a>
                <a className="insta" href="https://www.instagram.com/banknoteeg/">

                    <img src="/socialicons/Insta.svg" alt="" />
                </a>
            </div>
        </div>
    )
}

export default Footer